// extracted by mini-css-extract-plugin
export default {"PopupFrame":"styles_PopupFrame__L0trm","context":"styles_context__M6dpr"};